import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EmployeeTraining } from './training';
import { AppConfig, AppConfigKeys } from '../app.config';

@Injectable({
    providedIn: 'root',
})
export class TrainingService {
    #http: HttpClient = inject(HttpClient);
    #appConfig = inject(AppConfig);
    #apiUrl = this.#appConfig.get(AppConfigKeys.ApiUrl);

    getEmployeeTrainings(): Observable<EmployeeTraining[]> {
        const url: string = this.#apiUrl + 'employee/trainings';

        return this.#http.get<EmployeeTraining[]>(url);
    }

    startEmployeeTraining(id: string): Observable<EmployeeTraining> {
        const url: string = this.#apiUrl + 'employee/training/start/' + id;

        return this.#http.get<EmployeeTraining>(url);
    }

    updateEmployeeTraining(training: EmployeeTraining): Observable<EmployeeTraining> {
        const url: string = this.#apiUrl + 'employee/training/update/' + training.answeredId;

        return this.#http.put<EmployeeTraining>(url, training);
    }
    submitEmployeeTraining(training: EmployeeTraining): Observable<EmployeeTraining> {
        const url: string = this.#apiUrl + 'employee/training/submit/' + training.answeredId;

        return this.#http.put<EmployeeTraining>(url, training);
    }
    restartEmployeeTraining(training: EmployeeTraining): Observable<EmployeeTraining> {
        const url: string = this.#apiUrl + 'employee/training/restart/' + training.answeredId;

        return this.#http.put<EmployeeTraining>(url, training);
    }
}
